// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a1f3a7f4","239":"17cc3351","453":"55098f35","455":"09718fbc"}[chunkId] + ".chunk.js";
};